//@vendor
const get = require('lodash/object/get');

const actionTypes = require('../loansConstants/actionTypes');
const { APIGet } = require('utilities/APIRequestHelper');

const fetchLoanInterveners = loanId => ({
    type: actionTypes.FETCH_LOAN_INTERVENERS,
    payload: {
        loanId
    }
});

const fetchLoanIntervenersSuccess = (loanId, data) => ({
    type: actionTypes.FETCH_LOAN_INTERVENERS_SUCCESS,
    payload: {
        loanId,
        interveners: get(data, 'listaIntervinientes.lista', []) || [],
        nextPage: get(data, '_links.nextPage.href', '') || ''
    }
});

const fetchLoanIntervenersFailure = (loanId, error) => ({
    type: actionTypes.FETCH_LOAN_INTERVENERS_FAILURE,
    payload: {
        loanId,
        error
    }
});

const requestLoanInterveners = loanId => (dispatch, getState) => {
    const loan = getState().loans.getIn(['byId', loanId]);
    if (loan.getIn(['interveners', 'success'])) {
        return Promise.resolve();
    }

    const detailsRequestData = {
        query: {
            producto: loan.get('newProduct'),
            numeroContrato: loan.get('newContractNumber')
        }
    };

    dispatch(fetchLoanInterveners(loanId));
    return APIGet({dispatch, endpoint: 'loansAndMortgagesInterveners', params: detailsRequestData})
        .then(response => dispatch(fetchLoanIntervenersSuccess(loanId, response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(fetchLoanIntervenersFailure(loanId, response.error));
            } else throw response;
        });
};

module.exports = { requestLoanInterveners };
